import React, { Component, Fragment } from "react";
import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import {
	Card,
	Spin,
	Row,
	Button,
	Form,
	Popconfirm,
	Icon,
	Tooltip,
	message,
	Upload
} from "antd";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import { locationPrefix } from "common/general";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";
import ImportFilesDialog from "components/ImportFilesDialog";
import AddEditEmailDialog from "./components/AddEditEmailDialog";
import { Guides } from "common/guides";
// import AddEditAccountDialog from "./components/AddEditAccountDialog";

const FormItem = Form.Item;

function getTextFilter(type) {
	function TextFilter() {}

	TextFilter.prototype.init = function(params) {
		this.valueGetter = params.valueGetter;
		this.filterText = null;
		this.setupGui(params);
	};

	// not called by ag-Grid, just for us to help setup
	TextFilter.prototype.setupGui = function(params) {
		this.gui = document.createElement("div");
		this.gui.innerHTML =
			'<div style="padding: 4px;">' +
			'<div style="font-weight: bold;">Search for ' +
			type +
			"</div>" +
			'<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="' +
			type +
			'..."/></div>' +
			'<div style="margin-top: 5px; width: 200px;">Enter ' +
			type +
			" that you want to search for</div>" +
			"</div>";

		this.eFilterText = this.gui.querySelector("#filterText");
		this.eFilterText.addEventListener("changed", listener);
		this.eFilterText.addEventListener("paste", listener);
		this.eFilterText.addEventListener("input", listener);
		// IE doesn't fire changed for special keys (eg delete, backspace), so need to
		// listen for this further ones
		this.eFilterText.addEventListener("keydown", listener);
		this.eFilterText.addEventListener("keyup", listener);
		this.filterChangedCallback = params.filterChangedCallback;

		var that = this;

		function listener(event) {
			that.filterText = event.target.value;
			params.filterChangedCallback();
		}
	};

	TextFilter.prototype.getGui = function() {
		return this.gui;
	};

	TextFilter.prototype.doesFilterPass = function(params) {
		// make sure each word passes separately, ie search for firstname, lastname
		var passed = true;
		var valueGetter = this.valueGetter;
		var value = valueGetter(params);
		if (
			value
				.toString()
				.toLowerCase()
				.indexOf(this.filterText.toLowerCase()) < 0
		) {
			passed = false;
		}
		if (passed && this.filterText.toLowerCase() == "wordpress.com") {
			console.log(params);
		}
		return passed;
	};

	TextFilter.prototype.isFilterActive = function() {
		var isActive =
			this.filterText !== null &&
			this.filterText !== undefined &&
			this.filterText !== "";
		return isActive;
	};

	TextFilter.prototype.getApi = function() {
		var that = this;
		return {
			getModel: function() {
				var model = { value: that.filterText.value };
				return model;
			},
			setModel: function(model) {
				that.eFilterText.value = model.value;
			}
		};
	};

	TextFilter.prototype.getModelAsString = function(model) {
		return model ? model : "";
	};

	TextFilter.prototype.getModel = function() {
		return this.filterText;
	};
	// lazy, the example doesn't use setModel()
	TextFilter.prototype.setModel = function(params) {
		if (!params) {
			this.filterText = "";
			this.eFilterText.value = "";
			this.filterChangedCallback();
		}
	};

	return TextFilter;
}

var sslRenderer = function(params) {
	if (params.value == true) {
		return '<span class="ag-icon ag-icon-checkbox-checked"></span>';
	} else {
		return '<span class="ag-icon ag-icon-checkbox-unchecked"></span>';
	}
};

@inject("rootStore")
@observer
class EmailManagerPage extends Component {
	createGridDefs(columnDefs) {
		const gridDefs = {
			columnDefs: [
				{
					headerName: "Email Address",
					field: "address",
					editable: false,
					filter: getTextFilter("Email Address"),
					headerCheckboxSelection: true,
					checkboxSelection: true
				},
				{
					headerName: "Email Login",
					field: "login",
					editable: false,
					filter: getTextFilter("Email Login")
				},
				{
					headerName: "Email Password",
					field: "password",
					editable: false,
					filter: getTextFilter("Password")
				},
				{
					headerName: "Email Server",
					field: "server",
					editable: false,
					filter: getTextFilter("Server Address")
				},
				{
					headerName: "Port",
					field: "port",
					editable: false,
					filter: getTextFilter("Server Port"),
					width: 80,
					maxWidth: 80
				},
				{
					headerName: "Protocol",
					field: "protocol",
					editable: false,
					width: 100,
					maxWidth: 100
				},
				{
					headerName: "SSL",
					field: "ssl",
					editable: false,
					cellRenderer: sslRenderer,
					width: 80,
					maxWidth: 80
				},
				{
					headerName: "Used",
					colId: 'used',
					field: "used",
					editable: false,
					cellRenderer: sslRenderer,
					width: 80,
					maxWidth: 80
				}
				// {
				// 	headerName: "Password",
				// 	field: "password",
				// 	editable: false,
				// 	suppressFilter: true
				// }
			],
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	deleteEmails = () => {
		const {
			rootStore: { emailStore }
		} = this.props;

		if (this.gridApi != null) {
			let emailAddresses = [];
			for (let node of this.gridApi.getSelectedNodes()) {
				const account = node.data;
				emailAddresses.push(account.address);
			}
			emailStore.remoteDeleteEmails(emailAddresses);
		}
	};

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	componentWillUnmount() {
		if (this.deleteEmailDisposer != null) {
			this.deleteEmailDispoer();
		}

		if (this.newEmailDisposer != null) {
			this.newEmailDisposer();
		}

		if (this.updatEmailDisposer != null) {
			this.updateEmailDisposer();
		}

		if (this.importEmailsDisposer != null) {
			this.importEmailsDisposer();
		}
	}

	showAddAccountDialog = () => {
		const {
			rootStore: { accountsStore }
		} = this.props;

		accountsStore.showAddAccountDialog();
	};

	onGridReady = params => {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		const {
			rootStore: { emailStore }
		} = this.props;

		const ui = emailStore.ui;

		this.deleteEmailsDisposer = autorun(() => {
			if (ui.deletedEmails != null) {
				let fullDeletedEmails = ui.deletedEmails.map(address => {
					return { address: address };
				});
				this.gridApi.updateRowData({
					remove: fullDeletedEmails
				});
			}
		});

		// this.newAccountDisposer = autorun(() => {
		// 	if (ui.newAccount != null) {
		//         const currentAccount = this.gridApi.getRowNode(
		// 			ui.newAccount.siteName + "_" + ui.newAccount.email
		//         );

		//         if (currentAccount == null) {
		//             this.gridApi.updateRowData({
		//                 add: [ui.newAccount]
		//             });
		//         } else {
		//             this.gridApi.updateRowData({
		//                 update: [ui.newAccount]
		//             });
		//         }
		// 	}
		// });

		// this.updateAccountDisposer = autorun(() => {
		// 	console.log("Updated account");
		// 	if (ui.updatedAccount != null) {
		// 		this.gridApi.updateRowData({
		// 			update: [ui.updatedAccount]
		// 		});
		// 	}
		// });

		this.importEmailsDisposer = autorun(() => {
			console.log("Imported Emails");
			let updatedEmails = [];
			let newEmails = [];
			for (let email of ui.importedEmails) {
				const currentEmail = this.gridApi.getRowNode(email.address);
				if (currentEmail == null) {
					newEmails.push(email);
				} else {
					updatedEmails.push(email);
				}
			}
			if (ui.importedEmails != null) {
				this.gridApi.updateRowData({
					add: newEmails,
					update: updatedEmails
				});
			}
		});

		this.gridApi.sizeColumnsToFit();
	};

	showImportEmailsDialog = () => {
		const {
			rootStore: { emailStore }
		} = this.props;

		emailStore.showImportEmailsDialog();
	};

	showAddEmailDialog = () => {
		const {
			rootStore: { emailStore }
		} = this.props;

		emailStore.showAddEmailDialog();
	};

	hideImportEmailsDialog = () => {
		const {
			rootStore: { emailStore }
		} = this.props;

		emailStore.hideImportEmailsDialog();
	};

	onChange = file => {
		console.log(file);
	};

	render() {
		const {
			rootStore: { emailStore }
		} = this.props;

		const ui = emailStore.ui;

		let breadcrumbList = "";

		// let downloadAccountsHref = "";
		// if (!ui.loadingAccounts) {
		// 	breadcrumbList = [
		// 		{
		// 			title: "Home",
		// 			href: locationPrefix + "/"
		// 		},
		// 		{
		// 			title: "Campaigns",
		// 			href: locationPrefix + "/"
		// 		},
		// 		{
		// 			title: "Campaign",
		// 			href: locationPrefix + "/campaign/" + accountsStore.campaign.id
		// 		},
		// 		{
		// 			title: "Accounts"
		// 		}
		// 	];
		// 	downloadAccountsHref =
		// 		"/action/export/profile/" + accountsStore.profile.id;
		// }

		// let spinning = ui.loadingAccounts == true || ui.deletingAccounts == true;
		const gridDefs = this.createGridDefs();

		// const props = {
		// 	name: "file",
		// 	action: "/action/import/profile/" + accountsStore.profile.id,
		// 	showUploadList: false,
		// 	onChange: (info) => {
		// 		if (info.file.status == "uploading") {
		// 			accountsStore.startImportingAccounts();
		// 			return;
		// 		}
		// 		// if (info.file.status !== "uploading") {
		// 		// 	console.log(info.file, info.fileList);
		// 		// }
		// 		if (info.file.status === "done") {
		// 			accountsStore.completeImportingAccounts();
		// 			if (info.file.response && info.file.response.error) {
		// 				message.error(info.file.response.error.message, 5);
		// 				return;
		// 			}
		// 			message.success(`${info.file.name} file uploaded successfully`);
		// 		} else if (info.file.status === "error") {
		// 			message.error(`${info.file.name} file upload failed.`);
		// 			accountsStore.completeImportingAccounts();
		// 		}
		// 	}
		// };

		let spinning = false;
		let emails = emailStore.emails;
		// let emails = [
		// 	{
		// 		address: "doan.chuvan@gmail.com",
		// 		login: "doan.chuvan@gmail.com",
		// 		password: "abcd1234",
		// 		server: "pop.gmail.com",
		// 		port: 995,
		// 		protocol: "IMAP",
		// 		ssl: true
		// 	},
		// 	{
		// 		address: "doan.chuvan1@gmail.com",
		// 		login: "doan.chuvan@gmail.com",
		// 		password: "abcd1234",
		// 		server: "pop.gmail.com",
		// 		port: 995,
		// 		protocol: "IMAP",
		// 		ssl: true
		// 	}
		// ];

		return (
			<Fragment>
				{ui.loadingEmails == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={"Email Manager"}
					>
						<AddEditEmailDialog />
						<ImportFilesDialog
							dialogVisible={ui.importEmailsDialogVisible}
							uploadingFiles={ui.importingEmails}
							hideDialog={this.hideImportEmailsDialog}
							multiple={true}
							title="Import Emails"
							hint={
								<Fragment>
									Supported format: <br />
									<b style={{ fontSize: 10 }}>
										email:login:password:server:port:protocol(POP3,IMAP):ssl(true,false)
									</b>
									<br />
									Example:
									<br />
									<b style={{ fontSize: 10 }}>
										seo@yahoo.com:seo@yahoo.com:mysecret:imap.mail.yahoo.com:993:IMAP:true
									</b>
								</Fragment>
							}
							uploadUrl={"/action/import/user_emails"}
						/>
						<Card>
							<Spin spinning={spinning}>
								<Row>
									<Form
										layout="inline"
										style={{ marginBottom: 8 }}
									>
										<FormItem>
											<Tooltip title="Add Email">
												<Button
													type="primary"
													onClick={
														this.showAddEmailDialog
													}
												>
													<Icon type="plus-square" />
												</Button>
											</Tooltip>
										</FormItem>
										<FormItem>
											<Tooltip title="Import emails">
												<Button
													type="primary"
													onClick={
														this
															.showImportEmailsDialog
													}
												>
													<Icon type="upload" />
												</Button>
											</Tooltip>
										</FormItem>
										<FormItem>
											<Popconfirm
												title="Do you want to delete the selected emails?"
												place
												ment="bottom"
												onConfirm={this.deleteEmails}
											>
												<Tooltip title="Delete selected emails">
													<Button type="primary">
														<Icon type="delete" />
													</Button>
												</Tooltip>
											</Popconfirm>
										</FormItem>
										<FormItem>
											<Tooltip title="How to use email manager">
												<a
													href={
														Guides[
															"email-manager"
														]
													}
													target="_blank"
													className="ant-btn ant-btn-primary ant-btn-circle"
												>
													<Icon type="question-circle" />
												</a>
											</Tooltip>
										</FormItem>
										{/* <FormItem>
											<Upload {...props}>
												<Button type="primary" loading={ui.importingAccounts}>
													<Icon type="upload" />
												</Button>
											</Upload>
										</FormItem> */}
										{/* <FormItem>
											<Button type="primary" href={downloadAccountsHref}>
												<Icon type="download" />
											</Button>
										</FormItem> */}
									</Form>
								</Row>
								<Row>
									<div
										style={{
											width: "100%",
											height:
												(window.screen.height * 3) / 4
										}}
									>
										<div
											style={{
												boxSizing: "border-box",
												height: "100%",
												width: "100%"
											}}
											className="ag-theme-balham"
										>
											<AgGridReact
												columnDefs={gridDefs.columnDefs}
												enableColResize={true}
												enableFilter={true}
												floatingFilter={true}
												enableSorting={true}
												rowData={emails}
												enableRangeSelection={true}
												rowSelection={
													gridDefs.rowSelection
												}
												suppressRowClickSelection={true}
												onRowSelected={
													this.onRowSelected
												}
												getRowNodeId={data => {
													return data.address;
												}}
												onSortChanged={e => {
													// console.log(
													// 	e.api.getSortModel()
													// );
												}}
												deltaRowDataMode={true}
												onGridReady={this.onGridReady}
											/>
										</div>
									</div>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}

export default EmailManagerPage;

// import React, { Component } from "react";
// import { Card, Table } from "antd";
// import PageHeaderLayout from "layouts/PageHeaderLayout";
// import { locationPrefix } from "common/general";
// import { inject, observer } from "mobx-react";

// @inject("rootStore")
// @observer
// class EmailManagerPage extends Component {
//     constructor(props) {
// 		super(props);
// 		this.state = {
// 			selectedRowKeys: []
//         };
// 	}

// 	render() {
// 		const breadcrumbList = [
// 			{
// 				title: "Home",
// 				href: locationPrefix + "/"
// 			},
// 			{
// 				title: "Email Manager",
// 				href: locationPrefix + "/email-manager"
// 			}
//         ];

//         const columns = [
// 			{
// 				title: "Email Address",
// 				dataIndex: "address",
// 				defaultSortOrder: "descend",
//                 sorter: (a, b) => {
// 					return ('' + a.name).localeCompare(b.name)
// 				}
//             },
// 			{
// 				title: "Email Login",
// 				dataIndex: "login",
//                 sorter: (a, b) => {
// 					return ('' + a.login).localeCompare(b.login)
// 				}
//             },
// 			{
// 				title: "Password",
// 				dataIndex: "password",
//             },
//             {
//                 title: "Server",
//                 dataIndex: "server"
//             },
//             {
//                 title: "Port",
//                 dataIndex: "port"
//             }
//         ];

//         const { selectedRowKeys } = this.state;

//         const rowSelection = {
// 			selectedRowKeys,
// 			onChange: (selectedRowKeys, selectedRows) => {
// 				this.setState({ selectedRowKeys });
// 			},
// 			getCheckboxProps: record => ({
// 				name: record.name
// 			})
//         };

//         let emails = [
//             {
//                 address: "doan.chuvan@gmail.com",
//                 login: "doan.chuvan@gmail.com",
//                 password: "abcd1234",
//                 server: "pop.gmail.com",
//                 port: 995
//             },
//             {
//                 address: "doan.chuvan1@gmail.com",
//                 login: "doan.chuvan@gmail.com",
//                 password: "abcd1234",
//                 server: "pop.gmail.com",
//                 port: 995
//             }
//         ]

// 		return (
// 			<PageHeaderLayout breadcrumbList={breadcrumbList}>
// 				<Card bordered={false}>
// 					<Table
// 						rowKey="address"
// 						rowSelection={rowSelection}
// 						columns={columns}
//                         dataSource={emails}
//                         size="small"
// 						pagination={{
// 							pageSize: 20
// 						}}
// 					/>
// 				</Card>
// 			</PageHeaderLayout>
// 		);
// 	}
// }

// export default EmailManagerPage;
